import { render, staticRenderFns } from "./TablePaymentsPending.vue?vue&type=template&id=0774c12d"
import script from "./TablePaymentsPending.vue?vue&type=script&lang=js"
export * from "./TablePaymentsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports